import { Injectable } from '@angular/core';
import {Observable, Subject} from "rxjs";
import {MesApiService} from "./mes-api.service";
import {NotificationMessage} from "./models/notification-message";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class MesNotificationService extends MesApiService{
  public progress$: Subject<NotificationMessage>;
  public queue$: Subject<{id: string, text: string}[]>;
  public openNotifications$: Subject<boolean>;

  constructor() {
    super('Notification');
    this.progress$ = new Subject<NotificationMessage>();
    this.queue$ = new Subject<{id: string, text: string}[]>();
    this.openNotifications$ = new Subject<boolean>();
  }

  cancelBackgroundTask(taskId: string): Observable<boolean> {
    return this.getSingle<boolean>({
      action: 'CancelBackgroundTask'
    }, {taskId: taskId}).pipe(map(value => {return value.data}));
  }

  clearPendingTasks(): Observable<string[]> {
    return this.getSingle<string[]>({action: 'CancelPendingTasks'})
      .pipe(map(value => {return value.data}));
  }

  testMessage() {
    return this.getSingle<any>({action: 'TestMessage'});
  }
}
